import { TweenMax, Power3 } from 'gsap'
import { bus } from '@/consts'

export default {
  name: 'LearnMore',
  template: '#learn-more-template',
  data () {
    return {}
  },
  mounted () {
    bus.$on('loadAnimation', () => {
      if (this.$refs.learnMore) {
        TweenMax.fromTo(this.$refs.learnMore, 2, {opacity: 0, x: -10}, {opacity: 1, x: 0, ease: Power3.easeInOut})
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/LearnMore.js